import { useLight } from "@Light/services/light";
import { useEnrollment } from "../flow/context";
import { requirementValue } from "../flow/screen";

export function usePatchedRate() {
  const { requirements } = useEnrollment();
  const { useGetEnrollPlanQuery } = useLight();

  const acceptance = requirementValue(requirements.acceptance);
  return useGetEnrollPlanQuery(acceptance.rate_id);
}
